// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"DropDown_dropdown__1CXO4"};